import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Collection from './Collection';
import Navbar from './Navbar';
import Popup from './Popup';
import Footer from './Footer';

const HomePage = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [popupShown, setPopupShown] = useState(false);

  const randomPopupTimer = () => {
    const delay = Math?.floor(Math.random() * (20000 - 7000)) + 7000;
    setTimeout(() => {
      if (!popupShown) {
        setShowPopup(true);
        setPopupShown(true);
      }
    }, delay);
  };

  useEffect(() => {
    if (!popupShown) {
      randomPopupTimer();
    }
  }, [popupShown]);

  const { auth } = useSelector((store) => store);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="flex flex-col">
      {/* Navbar */}
      <Navbar />

      {/* Spacer */}
      <div className="h-[100px] bg-black w-full"></div>

      {/* Hero Banner */}
      <div className="w-full">
        <img
          src="/homeMain.webp"
          alt="Banner"
          className="w-full h-auto object-cover"
        />
      </div>

      {/* Welcome Section */}
      <div className="text-center py-8 sm:py-16 bg-neutral-900 text-white px-4">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">
          Welcome to Nana Hana
        </h1>
        <p className="text-base sm:text-lg lg:text-xl max-w-4xl mx-auto leading-relaxed">
          Our brand is a fusion of various alternative fashion genres, from punk and goth to kawaii and streetwear.
          We aim to provide high-quality, unique designs that empower individuals to express their true selves.
        </p>
      </div>

      {/* Inclusivity Section */}
      <div className="text-center py-8 sm:py-16 bg-black text-white px-4">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6">
          Inclusivity and Diversity
        </h2>
        <p className="text-base sm:text-lg lg:text-xl max-w-4xl mx-auto leading-relaxed">
          Nana Hana is committed to inclusivity and gender neutrality. "Nana" is a gender-neutral name used in many languages, symbolizing our core values of embracing all forms of self-expression and breaking down traditional gender norms.
          Our designs are made for everyone, regardless of gender, celebrating the diverse beauty of individuality.
        </p>
      </div>

      {/* Popup */}
      {showPopup && !auth?.user && <Popup onClose={handleClosePopup} />}

      {/* Collection Section */}
      <Collection />
      <Footer/>
    </div>
  );
};

export default HomePage;
